import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/observable';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from '../../environments/environment';
import { SearchFilter } from '../models/search.model';

@Injectable()
export class SearchService
{
    endpoint = environment.apiEndpoint + '/Search/';
    constructor(private httpClient: HttpClient) { }

    getSearchResults$(searchFilter:SearchFilter):Observable<any>
    {
        const headers = new HttpHeaders().set('content-type', 'application/json');
        const body = searchFilter;
        return this.httpClient.post(this.endpoint+"GetSearchResults", body, {
          headers,
          observe: 'response'
        });
    }
    getQuickLinkResults$(fromDate:any, toDate:any):Observable<any>
    {
        const headers = new HttpHeaders().set('content-type', 'application/json');
        const body = [{ fromDate: fromDate, toDate: toDate}];
        return this.httpClient.post(this.endpoint+"GetQuickLinksResults?fromDate="+fromDate+"&toDate="+toDate, body, {
          headers,
          observe: 'response'
        });
    }


}


// WEBPACK FOOTER //
// ./src/app/services/search.service.ts